// export default function DashboardScoringTable() {
//   return (
//     <div style={{ padding: 16 }}>
//       <h2>Hello there</h2>
//       <p>DashboardScoringTable is temporarily disabled.</p>
//     </div>
//   );
// }

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DoerProgressModal from "./DoerProgressModal";

// ✅ Set your API base here (Cloud Run URL)
const API_BASE = process.env.REACT_APP_NAV_API || "http://localhost:8080";

function fmtDateInput(d) {
  const dt = new Date(d);
  const yyyy = dt.getFullYear();
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  const dd = String(dt.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

function safeStr(v) {
  if (v === null || v === undefined) return "";
  return String(v);
}

// ✅ Your score formula on TOTAL row
function calcScoreFromCounts(planned, done, notDone, doneDelay) {
  planned = Number(planned || 0);
  done = Number(done || 0);
  notDone = Number(notDone || 0);
  doneDelay = Number(doneDelay || 0);

  const notDoneScore = planned ? (notDone / planned) * -100 : 0;
  const doneDelayScore = done ? (doneDelay / done) * -100 : 0;

  const nd = Math.round(notDoneScore * 100) / 100;
  const dd = Math.round(doneDelayScore * 100) / 100;

  let avg;
  if (nd === -100 && dd === 0) avg = -100;
  else avg = (notDoneScore + doneDelayScore) / 2;

  return {
    TotalNotDone_Score: Math.round(notDoneScore * 100) / 100,
    TotalNotDoneOnTime_Score: Math.round(doneDelayScore * 100) / 100,
    Total_Average_Score: Math.round(avg * 100) / 100,
  };
}

function groupByDoer(rows) {
  const map = new Map();

  rows.forEach((r) => {
    const email = safeStr(r.User_Emails || r.Doer_Email || "").toLowerCase();
    const name = safeStr(r.User_Name || r.Doer_Name || "");
    const key = email || name || safeStr(r.__rowKey);

    if (!map.has(key)) map.set(key, []);
    map.get(key).push(r);
  });

  // sort inside group by Department then Process
  for (const arr of map.values()) {
    arr.sort((a, b) => {
      const d = safeStr(a.Department).localeCompare(safeStr(b.Department));
      if (d !== 0) return d;
      return safeStr(a.Process_Name).localeCompare(safeStr(b.Process_Name));
    });
  }

  return Array.from(map.entries()).map(([key, list]) => ({ key, list }));
}

function ScoreBadge({ value }) {
  const n = Number(value);
  const cls = isNaN(n)
    ? "badge"
    : n <= -20
    ? "badge badgeRed"
    : n < 0
    ? "badge badgeOrange"
    : "badge badgeGreen";
  return <span className={cls}>{safeStr(value)}</span>;
}

export default function DashboardScoringTable(){
  const [department, setDepartment] = useState("All");
  const [depts, setDepts] = useState([]);

  const [startDate, setStartDate] = useState(() => fmtDateInput(new Date()));
  const [endDate, setEndDate] = useState(() => fmtDateInput(new Date()));
  const navigate = useNavigate();
  const location = useLocation();

useEffect(() => {

  const params = new URLSearchParams(location.search);

  const dateParam = params.get("date");

  if (!dateParam) return;

  setStartDate(dateParam);
  setEndDate(dateParam);

  // ✅ use direct values
  fetchLive(true, dateParam, dateParam);

}, [location.search]);

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [err, setErr] = useState("");

  // details modal
  const [modalOpen, setModalOpen] = useState(false);
  const [activeRow, setActiveRow] = useState(null);
  const [gridLoading, setGridLoading] = useState(false);
  const [gridErr, setGridErr] = useState("");
  const [gridData, setGridData] = useState(null);

  const [search, setSearch] = useState("");
  const [isCustomDate, setIsCustomDate] = useState(false);
  // ✅ Previous Performance Modal
const [progressOpen, setProgressOpen] = useState(false);
const [selectedEmail, setSelectedEmail] = useState("");
const [penaltyPopupOpen, setPenaltyPopupOpen] = useState(false);
const [penaltyReason, setPenaltyReason] = useState("");

const [uidPopupOpen, setUidPopupOpen] = useState(false);
const [uidList, setUidList] = useState([]);

function openUidPopup(uids) {
  setUidList(uids);
  setUidPopupOpen(true);
}

const [helpPopupOpen, setHelpPopupOpen] = useState(false);
const [helpData, setHelpData] = useState(null);

function openHelpPopup(data) {
  setHelpData(data);
  setHelpPopupOpen(true);
}

  const [hodViewOpen, setHodViewOpen] = useState(false);
const [hodViewSubs, setHodViewSubs] = useState([]);

function openHodViewPopup(subs) {
  setHodViewSubs(Array.isArray(subs) ? subs : []);
  setHodViewOpen(true);
}
function closeHodViewPopup() {
  setHodViewOpen(false);
  setHodViewSubs([]);
}
  const groupedRows = useMemo(() => {
    const q = search.trim().toLowerCase();
    const base = !q
      ? rows
      : rows.filter((r) => {
          const hay = [
            r.User_Name,
            r.User_Emails,
            r.Location,
            r.Department,
            r.Department_Name_In_HRMantra,
            r.Process_Name,
            r.MobileNumber,
          ]
            .map(safeStr)
            .join(" | ")
            .toLowerCase();
          return hay.includes(q);
        });

    return groupByDoer(base);
  }, [rows, search]);

  // async function fetchLive() {
async function fetchLive(
  customDate = isCustomDate,
  sDate = startDate,
  eDate = endDate
) {
    setErr("");
    setLoading(true);
    try {
        // const doerEmail = (activeDoerEmail || "").trim().toLowerCase();

const url =
  `${API_BASE}/scoring/live` +
  `?department=${encodeURIComponent(department)}` +
  `&startDate=${encodeURIComponent(sDate)}` +
  `&endDate=${encodeURIComponent(eDate)}` +
  `&mode=dashboard` +
  // `&isCustomDate=${isCustomDate}` +
  `&isCustomDate=${customDate}` +
  `&showAll=false`;   // ✅ ADD THIS  // 🔥 KEY LINE

      const res = await fetch(url, {
  credentials: "include"
});
      const json = await res.json();
      if (!res.ok || !json.ok) throw new Error(json?.error || "Failed to load live data");
      setRows(Array.isArray(json.data) ? json.data : []);
    } catch (e) {
      setErr(e.message || String(e));
      setRows([]);
    } finally {
      setLoading(false);
    }
  }

  async function openDetails(row) {
    setActiveRow(row);
    setModalOpen(true);
    setGridData(null);
    setGridErr("");
    setGridLoading(true);

    try {
      const rowKey = row.__rowKey || row.Row_Key || row.rowKey;

      // ✅ If dropdown is "All", pass row's own department
      const deptForGrid = safeStr(row.Department || department || "Accounts");

const url =
  `${API_BASE}/scoring/grid` +
  `?department=${encodeURIComponent(deptForGrid)}` +
  `&startDate=${encodeURIComponent(startDate)}` +
  `&endDate=${encodeURIComponent(endDate)}` +
  `&rowKey=${encodeURIComponent(rowKey)}` +
  `&mode=dashboard` +                 // ✅ ADD THIS
  `&isCustomDate=${isCustomDate}`;    // ✅ ADD THIS
      const res = await fetch(url, {
  credentials: "include"
});
      const json = await res.json();
      if (!res.ok || !json.ok) throw new Error(json?.error || "Failed to load grid");
      setGridData(json.data || null);
    } catch (e) {
      setGridErr(e.message || String(e));
      setGridData(null);
    } finally {
      setGridLoading(false);
    }
  }

  function closeModal() {
    setModalOpen(false);
    setActiveRow(null);
    setGridData(null);
    setGridErr("");
    setGridLoading(false);
  }

function getScoreCellClass(value) {
  const n = Number(value);

  if (isNaN(n)) return "scoreFull";

  if (n > -20) {
    return "scoreFull scoreGreen";
  }

  if (n <= -20) {
    return "scoreFull scoreRed";
  }

  return "scoreFull";
}


function parseUIDsFromCell(v) {
  const text = String(v || "");
  const match = text.match(/\((.*?)\)/);
  if (!match) return [];
  return match[1].split(",").map(s => s.trim());
}

function getShortLabel(v) {
  const text = String(v || "").toUpperCase();

  const dMatch = text.match(/(\d+)D/);
  if (dMatch) {
    return `${dMatch[1]}D`;
  }

  const pMatch = text.match(/(\d+)P/);
  if (pMatch) {
    return `${pMatch[1]}P`;
  }

  return "";
}

function extractHelpTicketData(v) {
  const text = String(v || "");

  const stepMatch = text.match(/ST\d+/i);
  const step = stepMatch ? stepMatch[0].toUpperCase() : "";

  // ✅ NEW: detect Error
  const isError = text.toUpperCase().includes("ERROR");

  const planned = text.match(/Planned:\s*([^|]+)/i)?.[1]?.trim() || "";
  const actual = text.match(/Actual:\s*([^|]+)/i)?.[1]?.trim() || "";
  const delay = text.match(/Delay:\s*([^\]]+)/i)?.[1]?.trim() || "";

  return {
    step: isError ? `${step}(Error)` : step,   // ✅ FIX
    details: {
      Planned: planned,
      Actual: actual,
      Delay: delay
    }
  };
}
function renderStepCell(
  v,
  openUidPopup,
  openHelpPopup,
  department
) {

  if (!v) return "";

  const text = String(v);

  // ✅ Help Ticket logic (KEEP SAME)
  if (text.includes("Planned:")) {

    const { step, details } = extractHelpTicketData(v);

    return (
      <span
        style={{
          cursor: "pointer",
          fontWeight: 700,
          textDecoration: "underline",
          color: step.includes("Error")
            ? "#dc2626"
            : "inherit"
        }}
        onClick={(e) => {
          e.stopPropagation();
          openHelpPopup(details);
        }}
      >
        {step}
      </span>
    );
  }

  const shortLabel = getShortLabel(v);

  // ✅ NEW LOGIC
  // Accounts / Risk / Dealing
  // NO popup
  // NO underline
  // Show Error directly

  const parenMatch = text.match(/\((.*?)\)/);
  const parenContent = parenMatch ? parenMatch[1].trim().toUpperCase() : null;
  const isMainFmsStyleCell = !parenMatch || parenContent === 'ERROR' || parenContent === 'ADJUSTED';

  if (
    department === "Accounts" ||
    department === "Risk" ||
    department === "Dealing" ||
    isMainFmsStyleCell
  ) {

    const isError = text.toUpperCase().includes("ERROR");

    return isError
      ? `${shortLabel}(Adjusted)`
      : shortLabel;
  }
  // ✅ Existing popup logic for HR etc
  const uids = parseUIDsFromCell(v);

  if (!uids.length) return shortLabel;

  return (
    <span
      style={{
        cursor: "pointer",
        textDecoration: "underline",
        fontWeight: 600
      }}
      onClick={(e) => {
        e.stopPropagation();
        openUidPopup(uids);
      }}
    >
      {shortLabel}
    </span>
  );
}

function openProgressPopup(row) {
  const email = String(row.User_Emails || "")
    .split(",")[0]
    .trim()
    .toLowerCase();

  setSelectedEmail(email);
  setProgressOpen(true);
}

  // ✅ Load meta only once
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/scoring/meta`, {
  credentials: "include"
});
        const json = await res.json();
        if (res.ok && json.ok) {
          const list = json.data?.departments || [];
          setDepts(list);
          if (list.includes("All")) setDepartment("All");
          else if (list.length) setDepartment(list[0]);
        }
      } catch (e) {
        console.warn("Meta load failed:", e);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ✅ Auto-load when Department changes
useEffect(() => {
  if (!department) return;

  // ✅ only initial load
  fetchLive();

  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [department]);

useEffect(() => {

  const interval = setInterval(() => {

    // ✅ don't refresh while modal open
    if (modalOpen) return;

    fetchLive(
      isCustomDate,
      startDate,
      endDate
    );

  }, 10 * 60 * 1000);

  return () => clearInterval(interval);

}, [
  department,
  startDate,
  endDate,
  isCustomDate,
  modalOpen
]);



  const COLS = 13;

  return (
    <div className="dstWrap">
      <div className="dstHeader">

        <div className="dstControls">


          <div className="ctrl">
            <label>Start</label>
            <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          </div>

          <div className="ctrl">
            <label>End</label>
            <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
          </div>

          

          {/* ✅ Load button only for date refresh */}
    
<button
  className="btnPrimary"
  onClick={() => {
    setIsCustomDate(true);
    fetchLive(true);
  }}
  disabled={loading}
>
            {loading ? "Loading..." : "Load"}
          </button>

          {/* <button
            className="btnPrimary"
            onClick={() => navigate("/error-correction")}
          >
            Error Correction
          </button> */}
        </div>
      </div>

      {err ? <div className="alertErr">⚠️ {err}</div> : null}

      <div className="tableCard">
        

        <div className="tableScroll">
          <table className="dstTable">

<thead>
  <tr>
    <th className="col-date">Date</th>
    <th className="col-process">Process Name</th>
    <th className="col-num">Total<br/>Task</th>
    <th className="col-num">Task<br/>Done</th>
    <th className="col-num">Task<br/>Not Done</th>
    <th className="col-num">Done<br/>OnTime</th>
    <th className="col-num">Done<br/>Delay</th>
    <th className="col-cumulative">Cumulative<br/>Score</th>
    <th className="col-score">Total<br/>Score</th>
    <th className="col-final">Final<br/>Score</th>
    <th className="col-icon">Details</th>
    <th className="col-icon">Previous Performance</th>
    <th className="col-approval">Score Adjustment Remarks</th>
  </tr>
</thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={COLS} className="centerCell">
                    Loading...
                  </td>
                </tr>
              ) : groupedRows.length === 0 ? (
                <tr>
                  <td colSpan={COLS} className="centerCell">
                    No Pending Task
                  </td>
                </tr>
              ) : (
                groupedRows.map((g, gIdx) => {
                  const list = g.list;

                  // ✅ TOTAL should be only if doer appears in 2+ Departments (not based on number of rows)
                  const deptCount = new Set(list.map((r) => safeStr(r.Department))).size;
                  const hasTotal = deptCount > 1;

                  // totals across departments
                  const totals = list.reduce(
                    (acc, r) => {
                      acc.total += Number(r.Total_Planned ?? r.Total_Task ?? 0);
                      acc.done += Number(r.Task_Done ?? 0);
                      acc.notDone += Number(r.Task_Not_Done ?? 0);
                      acc.onTime += Number(r.TaskDoneOnTime ?? 0);
                      acc.delay += Number(r.TaskDoneNotOnTime ?? 0);
                      return acc;
                    },
                    { total: 0, done: 0, notDone: 0, onTime: 0, delay: 0 }
                  );

                  const score = calcScoreFromCounts(
                    totals.total,
                    totals.done,
                    totals.notDone,
                    totals.delay
                  );

                  return (
                    <React.Fragment key={g.key + "|" + gIdx}>
                      {list.map((r, idx) => {
                        const dateRange = safeStr(r.Date_Range || r.date_range || r.dateRange || "");
                        const doer = safeStr(r.User_Name || r.Doer_Name || "");
                        const email = safeStr(r.User_Emails || r.Doer_Email || "");

                        const mobile = safeStr(r.MobileNumber || r.Mobile_Number || "");
                        const loc = safeStr(r.Location || "");
                        const hrDept = safeStr(r.Department_Name_In_HRMantra || "");
                        const dept = safeStr(r.Department || "");
                        const total = r.Total_Planned ?? r.Total_Task ?? "";
                        const done = r.Task_Done ?? "";
                        const notDone = r.Task_Not_Done ?? r.Task_NotDone ?? "";
                        const onTime = r.TaskDoneOnTime ?? r.Task_Done_OnTime ?? "";
                        const delay = r.TaskDoneNotOnTime ?? r.Task_Done_Delay ?? "";

                        const cumulativeScore =
                         r.Cumulative_Total_Average_Score ??
                        
                         "";
                        const totalScore = r.Total_Average_Score ?? r.Total_Score ?? r.TotalScore ?? "";

                        const hod = r.Latest_Submission?.HOD_Approve_Rejection || "";

                        // ✅ rowSpan should include TOTAL row only if hasTotal=true
                       const rowSpan = idx === 0 ? list.length + (hasTotal ? 1 : 0) : 0; 

                        return (
                          <tr key={safeStr(r.__rowKey) + "|" + idx}>
<td className="col-date">
  {dateRange?.includes(" to ")
    ? (
        <>
          <div>{dateRange.split(" to ")[0]}</div>
          <div style={{ fontWeight: 600, color: "#64748b" }}>to</div>
          <div>{dateRange.split(" to ")[1]}</div>
        </>
      )
    : dateRange}
</td>
<td className="col-process">{dept}</td>

<td className="col-num">{safeStr(total)}</td>
<td className="col-num">{safeStr(done)}</td>
<td className="col-num col-notdone">{safeStr(notDone)}</td>
<td className="col-num">{safeStr(onTime)}</td>
<td className="col-num col-delay">{safeStr(delay)}</td>

<td className="col-cumulative">
  {cumulativeScore !== "" ? (
    <div className="cumulativeWrapper">
      <div className="cumulativeScore">
        {Number(cumulativeScore).toFixed(2)}
      </div>

      {r.Cumulative_Date_Range && (
        <div className="cumulativeDate">
          {r.Cumulative_Date_Range}
        </div>
      )}
    </div>
  ) : (
    <span className="mutedSmall">—</span>
  )}
</td>


  <td className={`col-score ${getScoreCellClass(totalScore)}`}>
  {totalScore !== "" ? totalScore : "—"}
</td>

<td
  className={`col-final ${getScoreCellClass(r.Final_Score)}`}
  style={{ cursor: r.Penalty_Score ? "pointer" : "default" }}
  onClick={() => {
    if (Number(r.Penalty_Score || 0) !== 0 && r.Penalty_Reason) {
      setPenaltyReason(r.Penalty_Reason);
      setPenaltyPopupOpen(true);
    }
  }}
>
  {Number(r.Penalty_Score || 0) !== 0 ? (
    <div style={{ display: "flex", flexDirection: "column", gap: 2 }}>
      
      {/* Final Score */}
      <div style={{ fontWeight: 600 }}>
        {Number(r.Final_Score || 0).toFixed(2)}
      </div>

      {/* Penalty */}
      <div style={{ fontSize: 10, color: "#ffffff" }}>
        Penalty: {Number(r.Penalty_Score || 0).toFixed(2)}
      </div>

    </div>
  ) : "—"}
</td>
                        
<td className="col-icon">
  <button className="btnGhost" onClick={() => openDetails(r)}>
     Details
  </button>
</td>

{idx === 0 ? (
  <td 
    rowSpan={rowSpan}
    className={`col-icon ${hasTotal ? "vCenter" : ""}`}
  >
    <button
      className="btnGhost"
      onClick={() => openProgressPopup(r)}
    >
      History
    </button>
  </td>
) : null}

<td className="col-approval">
  {(() => {
    const subs = getSubmissionsFromRow(r);
    const total = subs.length;
    const pending = subs.filter((s) => !s?.HOD_Approve_Rejection).length;

    if (total === 0) {
      return <span className="pill pillGray"></span>;
    }

    return (
      <div style={{ display: "grid", gap: 6 }}>
        <button className="btnGhost" onClick={() => openHodViewPopup(subs)}>
          View Approvals
        </button>

        <div className="mutedSmall">
          Total: <b>{total}</b> | Pending: <b>{pending}</b>
        </div>
      </div>
    );
  })()}
</td>
                          </tr>


                        );
                      })}

                      {/* ✅ TOTAL row ONLY when doer is in multiple departments */}
                      {hasTotal ? (
<tr className="totalRow">

  {/* ❌ Date column EMPTY */}
  <td></td>

  {/* ✅ Process column starts TOTAL */}
  <td style={{ fontWeight: 900 }}>TOTAL</td>

  <td>{totals.total}</td>
  <td>{totals.done}</td>
  <td>{totals.notDone}</td>
  <td>{totals.onTime}</td>
  <td>{totals.delay}</td>

  <td>—</td>

  <td className={getScoreCellClass(score.Total_Average_Score)}>
    {score.Total_Average_Score}
  </td>

  {/* Final Score column empty */}
  <td></td>

  {/* Details + Previous + Remarks */}
  <td colSpan={3}></td>

</tr>
                      ) : null}
                    </React.Fragment>
                  );
                })
              )}
            </tbody>

          </table>
        </div>
      </div>

      {/* =================== MODAL =================== */}
      {modalOpen ? (
        <div className="modalBackdrop" onMouseDown={closeModal}>
          <div className="modalCard" onMouseDown={(e) => e.stopPropagation()}>
            <div className="modalHeader">
              <div>
                <div className="modalTitle">Grid Details</div>
                <div className="mutedSmall">
                  {safeStr(activeRow?.User_Name)} • {safeStr(activeRow?.Process_Name)} •{" "}
                  {safeStr(activeRow?.Department || department)}
                </div>
              </div>
              <button className="btnClose" onClick={closeModal}>
                ✕
              </button>
            </div>

            <div className="modalBody">
              {gridLoading ? <div className="centerCell">Loading grid...</div> : null}
              {gridErr ? <div className="alertErr">⚠️ {gridErr}</div> : null}

              {!gridLoading && !gridErr && gridData ? (
                <GridRenderer
  department={safeStr(activeRow?.Department || department)}
  grid={gridData}
  renderStepCell={renderStepCell}
  openUidPopup={openUidPopup}
   openHelpPopup={openHelpPopup}
/>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}


{penaltyPopupOpen && (
  <div className="modalBackdrop" onMouseDown={() => setPenaltyPopupOpen(false)}>
    <div
      className="modalCard modernModal"
      style={{ width: "min(400px, 90vw)" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="modalHeader">
        <div className="modalTitle">⚠️ Penalty Reason</div>
        <button className="btnClose" onClick={() => setPenaltyPopupOpen(false)}>
          ✕
        </button>
      </div>

      <div className="modalBody">
        <div
          style={{
            padding: "10px",
            borderRadius: 10,
            background: "#fff7ed",
            border: "1px solid #fdba74",
            fontSize: 14,
            color: "#7c2d12"
          }}
        >
          {/* {penaltyReason || "No reason available"} */}
          {formatPenaltyReason(penaltyReason)}
        </div>

        <div className="modalActions">
          <button
            className="btnPrimary"
            onClick={() => setPenaltyPopupOpen(false)}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
)}
{helpPopupOpen && (
  <div className="modalBackdrop" onMouseDown={() => setHelpPopupOpen(false)}>
    <div
      className="modalCard"
      style={{ width: "min(400px, 90vw)" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="modalHeader">
        <div className="modalTitle">Step Details</div>
        <button className="btnClose" onClick={() => setHelpPopupOpen(false)}>
          ✕
        </button>
      </div>

      <div className="modalBody" style={{ display: "grid", gap: 8 }}>
        <div><b>Planned:</b> {helpData?.Planned || "—"}</div>
        <div><b>Actual:</b> {helpData?.Actual || "—"}</div>
        <div><b>Delay:</b> {helpData?.Delay || "—"}</div>
      </div>
    </div>
  </div>
)}
{uidPopupOpen && (
  <div className="modalBackdrop" onMouseDown={() => setUidPopupOpen(false)}>
    <div
      className="modalCard"
      style={{ width: "min(400px, 90vw)" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="modalHeader">
        <div className="modalTitle">Unique IDs</div>
        <button className="btnClose" onClick={() => setUidPopupOpen(false)}>
          ✕
        </button>
      </div>

      <div className="modalBody" style={{ display: "grid", gap: 6 }}>
        {uidList.map((uid, i) => (
          <div
            key={i}
            style={{
              padding: "6px 10px",
              borderRadius: 8,
              background: "#f1f5f9",
              fontSize: 13
            }}
          >
            {uid}
          </div>
        ))}

        {uidList.length === 0 && (
          <div className="mutedSmall">No IDs</div>
        )}
      </div>
    </div>
  </div>
)}
      {hodViewOpen ? (
  <div className="modalBackdrop" onMouseDown={closeHodViewPopup}>
    <div
      className="modalCard"
      style={{ width: "min(860px, 96vw)" }}
      onMouseDown={(e) => e.stopPropagation()}
    >
      <div className="modalHeader">
        <div>
          <div className="modalTitle">HOD Approvals (All Forms)</div>
          <div className="mutedSmall">
            {safeStr(hodViewSubs?.[0]?.Doer_Name || "—")} •{" "}
            {safeStr(hodViewSubs?.[0]?.Doer_Email || "—")}
          </div>
        </div>
        <button className="btnClose" onClick={closeHodViewPopup}>✕</button>
      </div>

      <div className="modalBody" style={{ display: "grid", gap: 10 }}>
        {hodViewSubs.length === 0 ? (
          <div className="mutedSmall">No submissions found.</div>
        ) : null}

        {hodViewSubs.map((sub, i) => {
          const status = sub?.HOD_Approve_Rejection || "Pending";

          return (
            <div
              key={safeStr(sub?.Process_Key) + "|" + i}
              className="processCard"
              style={{ background: "#fff" }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", gap: 10, alignItems: "center" }}>
                <div style={{ fontWeight: 900 }}>
                  {safeStr(sub?.Process_Name || "—")}
                </div>

                <span
                  className={
                    status === "Accepted"
                      ? "pill pillGreen"
                      : status === "Rejected"
                      ? "pill pillRed"
                      : "pill pillOrange"
                  }
                >
                  {status}
                </span>
              </div>

              <div className="mutedSmall" style={{ display: "grid", gap: 4, marginTop: 6 }}>
                <div><b>Grid Date:</b> {safeStr(sub?.Grid_Date || "—")}</div>
                <div><b>Remarks Type:</b> {safeStr(sub?.Remarks_Type || "—")}</div>
                <div><b>Remarks:</b> {safeStr(sub?.Remarks_Text || "—")}</div>
                {status === "Rejected" ? (
                  <div><b>Reject Remark:</b> {safeStr(sub?.HOD_Reject_Remark || "—")}</div>
                ) : null}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </div>
) : null}

      {/* Local CSS */}
      <style>{`

.dstHeader{
  display:flex;
  justify-content:flex-start;
  align-items:center;
  margin-bottom:10px;
}

.dstControls{
  display:flex;
  gap:10px;
  align-items:end;
  padding: 0px 1px
}
        .ctrl{ display:flex; flex-direction:column; gap:4px;}
        .ctrl label{ font-size:11px; color:#6b7280;}
        .ctrl input, .ctrl select{
          height:28px; font-size:11px; padding:0 6px; border:1px solid #d1d5db; border-radius:5px; outline:none; min-width:150px;
          background:#fff;
        }
        .btnPrimary{
          height:28px; padding:0 20px; border:none; border-radius:5px; cursor:pointer;font-size:11px;
          background:#1948a4; color:#fff; font-weight:600;
        }
        .btnPrimary:disabled{ opacity:.6; cursor:not-allowed; }
        .alertErr{
          background:#fee2e2; border:1px solid #fecaca; color:#991b1b; padding:10px 12px; border-radius:10px; margin:10px 0;
        }

        .tableCard{  border-radius:5px; overflow:hidden; }
        .tableMeta{ display:flex; justify-content:space-between; padding:10px 12px; border-bottom:1px solid #e5e7eb; font-size:12px; }
        .muted{ color:#6b7280; }
        .mutedSmall{ color:#6b7280; font-size:11px; }

          .tableScroll{
  overflow-y:auto;
  overflow-x:auto;   /* ✅ IMPORTANT */
  max-height:70vh;
}
.cumulativeWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
  .col-date {
  position: sticky;
  left: 0;
  z-index: 5;
  background: #fff;
  min-width: 120px;
  max-width: 120px;
}

.col-process {
  position: sticky;
  left: 120px;   /* same as date width */
  z-index: 6;
  background: #fff;
  min-width: 140px;
  max-width: 140px;
}

/* header fix */
.dstTable thead .col-date,
.dstTable thead .col-process {
  z-index: 7;
  background: #1948a4;
  color: #fff;
}
  .col-num { min-width: 80px; text-align: center; }
.col-cumulative { min-width: 160px; text-align: center; }
.col-score { min-width: 80px; text-align: center; }
.col-final { min-width: 90px; text-align: center; }

.col-icon { min-width: 90px; text-align: center; }
.col-approval { min-width: 140px; }

.cumulativeScore {
  background-color: #afd2f0;   /* Blue */
  color: #000;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 12px;
  min-width: 60px;
  text-align: center;
}
.col-notdone {
  color: #dc2626;
  font-weight: 700;
}

.col-delay {
  color: #dc2626;
  font-weight: 700;
}
.cumulativeDate {
  font-size: 10px;
  color: #575f6b;
  text-align: center;
}
        .vCenter{
  vertical-align: middle !important;
}
.dstTable{
  width:100%;
  border-collapse:collapse;
  font-size:11px;
  background:#fff;

  margin-right:auto;   /* pushes table to right */
  margin-left:0;
}
/* Header */
.dstTable thead th{
  position:sticky;
  top:0;
  z-index:2;
  background:#1948a4;
  color:#fff;
  padding:6px 8px;
  text-align:left;
  border:1px solid #cbd5e1;   /* 🔥 vertical + horizontal */
  white-space:normal;
  word-break:break-word;
  font-size:11px
}

/* Body cells */
.dstTable tbody td{
  padding:6px 8px;
  border:1px solid #bec2c7;   /* 🔥 full grid lines */
  vertical-align:top;
  white-space:normal;
  word-break:break-word;
  font-size:11px
}


/* Remove hover color (optional for clean look) */
.dstTable tbody tr:hover{
  background:#f9fafb;
}
        .centerCell{ text-align:center; padding:18px 8px; color:#6b7280; }

        .name{ line-height:1.1; }

.btnGhost{
  display:inline-flex;
  align-items:center;
  justify-content:center;
  min-width:100px;
  padding:6px 10px;
  border-radius:6px;
  border:1px solid #cbd5e1;
  background:#f8fafc;
  cursor:pointer;
  font-weight:700;
  font-size:11px;
  transition:all .2s ease;
}

.btnGhost:hover{
  background:#1f4e8c;
  color:#fff;
  border-color:#1f4e8c;
}


        .pill{ padding:4px 10px; border-radius:999px; font-weight:700; font-size:11px; display:inline-block; }
        .pillGray{ background:#f1f5f9; color:#334155; }
        .pillGreen{ background:#dcfce7; color:#166534; }
        .pillRed{ background:#fee2e2; color:#991b1b; }

        .badge{
  padding:4px 12px;
  border-radius:8px;   /* less round like screenshot */
  font-weight:800;
  font-size:11px;
  display:inline-block;
}
        .badgeGreen{ background:#dcfce7; color:#166534; border-color:#bbf7d0; }
        .badgeOrange{ background:#ffedd5; color:#9a3412; border-color:#fed7aa; }
        .badgeRed{ background:#fee2e2; color:#991b1b; border-color:#fecaca; }

        /* Modal */
        .modalBackdrop{
          position:fixed; inset:0; background:rgba(15,23,42,.45);
          display:flex; align-items:center; justify-content:center; padding:16px; z-index:9999;
        }
        .modalCard{
          width:min(1600px, 96vw);
          max-height:86vh;
          background:#fff; border-radius:16px; overflow:hidden; box-shadow:0 12px 40px rgba(0,0,0,.2);
          display:flex; flex-direction:column;
        }
        .modalHeader{
          display:flex; justify-content:space-between; align-items:center;
          padding:12px 14px; border-bottom:1px solid #e5e7eb; background:#0b2e5a; color:#fff;
        }
        .modalTitle{ font-weight:900; font-size:14px; }
        .btnClose{
          background:rgba(255,255,255,.15); border:1px solid rgba(255,255,255,.25);
          color:#fff; width:34px; height:34px; border-radius:10px; cursor:pointer;
        }
        .modalBody{ padding:12px; overflow:auto; }

        /* Grid */
/* Grid - New UI Like Screenshot */

.processCard{
  background:#f3f4f6;
  border-radius:12px;
  padding:12px;
  border:1px solid #d1d5db;
}

.processTitle{
  font-weight:800;
  font-size:12px;
  margin-bottom:8px;
  display:flex;
  justify-content:space-between;
}

.processSteps{
  font-weight:600;
  color:#6b7280;
}

.gridTable{
  width:100%;
  border-collapse:collapse;
  font-size:11px;
  table-layout:fixed;   /* 🔥 important */
}

.gridTable th{
  background:#2f4a8a;
  color:#fff;
  font-weight:700;
  font-size:11px;
}
.gridTable th,
.gridTable td{
  width:68px;           /* 🔥 fixed width for all step columns */

  padding:6px 4px;
  text-align:center;
  border:1px solid #d1d5db;
  overflow:hidden;
}

.processGridWrap{
  display:grid;
  grid-template-columns: repeat(2, 1fr);
  gap:16px;
}

.processCard{
  background:#f3f4f6;
  border-radius:12px;
  padding:12px;
  border:1px solid #d1d5db;
}

/* If step count is more than 12, take full row */
.processCard.fullWidth{
  grid-column: span 2;
}

/* 🔴 Delay → red text */
.cellDelay {
  color: #dc2626;
  font-weight: 800;
}

/* 🟡 Pending → yellow bg + black text */
.cellPlanned {
  background: #fef3c7;
  color: #000;
  font-weight: 800;
}

/* optional */
.cellDone {
  background: #dcfce7;
  color: #166534;
}

.cellND {
  background: #fee2e2;
  color: #991b1b;
}

.cellNA {
  background: #f1f5f9;
  color: #64748b;
}
.totalRow td{
  font-weight:800;
  vertical-align:middle;
}

/* Apply yellow ONLY from Process column */
.totalRow td:nth-child(n+2){
  background:#f5d432;
  border:1px solid #e7c54b;
  text-align: center;
}
/* Make TOTAL text left aligned */
.scoreFull{
  text-align:center;
  font-weight:700;
}

.scoreGreen{
  background:#31c158;
  color:#000000;
}

.scoreRed{
  background:#ff5050;
  color:#000000;
}

  .dateCol{
  width:110px !important;
  min-width:110px !important;
  max-width:110px !important;
  text-align:left !important;
  font-weight:700;
  background:#ffffff;
  position:sticky;
  left:0;
  z-index:1;
}
  .dateColSmall {
  width: 50px !important;
  min-width: 50px !important;
  max-width: 50px !important;
}
.gridTable th.dateCol{
  background:#2f4a8a !important;
  color:#fff !important;
  z-index:2;
}
      `}</style>

      <DoerProgressModal
  email={selectedEmail}
  open={progressOpen}
  onClose={() => setProgressOpen(false)}
/>
    </div>
  );
}

/* =================== GRID RENDERERS =================== */

function GridRenderer({ department, grid, renderStepCell, openUidPopup, openHelpPopup }) {
  const combined = Array.isArray(grid.Combined_StepWise_Table) ? grid.Combined_StepWise_Table : [];
  const indent = Array.isArray(grid.Indent_Stepwise_Grid) ? grid.Indent_Stepwise_Grid : [];
  const notDone = Array.isArray(grid.Not_Done_Level_Grid) ? grid.Not_Done_Level_Grid : [];
  const doneLate = Array.isArray(grid.DoneNotOnTime_Level_Grid) ? grid.DoneNotOnTime_Level_Grid : [];

  if ((department === "Accounts" || department === "Risk" || department === "HR" || department === "Dealing") && combined.length) {
    // ✅ NEW: per-process step columns (no global 15/55)
    return (
<PerProcessStepwiseGrid
  department={department}
  rows={combined}
  stepMeta={grid.stepMeta || {}}
  renderStepCell={renderStepCell}
  openUidPopup={openUidPopup}
  openHelpPopup={openHelpPopup}
/>
);
  }

  if ((department === "Inward" || department === "Outward") && indent.length) {
    return <GenericObjectGrid title="Indent Stepwise Grid" rows={indent} />;
  }

  // if (department === "Help Ticket") {
  //   return (
  //     <div style={{ display: "grid", gap: 14 }}>
  //       {notDone.length ? <GenericObjectGrid title="Not Done Level Grid" rows={notDone} /> : null}
  //       {doneLate.length ? <GenericObjectGrid title="Done Not OnTime Level Grid" rows={doneLate} /> : null}

        if (department === "Help Ticket") {
  return (
    <div style={{ display: "grid", gap: 14 }}>
      {notDone.length ? (
        <GenericObjectGrid 
  title="Task Not Done Details" 
  rows={notDone}
  renderStepCell={renderStepCell}
  openUidPopup={openUidPopup}
  openHelpPopup={openHelpPopup}
  type="NOT_DONE"
  department={department}
/>
      ) : null}

      {doneLate.length ? (
<GenericObjectGrid 
  title="Task Delay Details" 
  rows={doneLate}
  renderStepCell={renderStepCell}
  openUidPopup={openUidPopup}
  openHelpPopup={openHelpPopup}
  type="DONE_LATE"
  department={department}
/>
      ) : null}
        {!notDone.length && !doneLate.length && combined.length ? (
  <PerProcessStepwiseGrid
  department={department}
  rows={combined}
  stepMeta={grid.stepMeta || {}}
  renderStepCell={renderStepCell}
  openUidPopup={openUidPopup}
  openHelpPopup={openHelpPopup}
/>
        ) : null}
        {!notDone.length && !doneLate.length && !combined.length ? (
          <div className="mutedSmall">No grid data available for this row.</div>
        ) : null}
      </div>
    );
  }

  if (combined.length) return (
<PerProcessStepwiseGrid
  department={department}
  rows={combined}
  stepMeta={grid.stepMeta || {}}
  renderStepCell={renderStepCell}
  openUidPopup={openUidPopup}
  openHelpPopup={openHelpPopup}
/>
);
  if (indent.length) return <GenericObjectGrid title="Grid" rows={indent} />;

  return <div className="mutedSmall">No grid data available for this row.</div>;
}

// ✅ NEW: One mini-table per Process_Name with only needed steps
function buildKeys_(prefix, count) {
  const keys = [];
  const p = String(prefix || "T").toLowerCase();
  for (let i = 1; i <= Number(count || 0); i++) {
    if (p === "step") keys.push(`Step${i}`);
    else keys.push(`T${String(i).padStart(2, "0")}`);
  }
  return keys;
}

function normalizeProc_(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/_+/g, "_");
}

function pickDate_(r) {
  return (
    r.Date_Task||
    ""
  );
}

function fmtDate_(v) {
  if (!v) return "";
  // handle "YYYY-MM-DD" or timestamp-like
  const s = String(v);
  return s.length >= 10 ? s.slice(0, 10) : s;
}

function groupByProcess_(rows, department) {
  const m = new Map();

  rows.forEach((r) => {
    const proc = safeStr(r.Process_Name || r.Process || r.FMS_Name || "Unknown");

    if (!m.has(proc)) m.set(proc, []);
    m.get(proc).push(r);
  });

  for (const arr of m.values()) {
    arr.sort((a, b) => {
      const da = new Date(pickDate_(a));
      const db = new Date(pickDate_(b));
      return da - db;
    });
  }

  return Array.from(m.entries()).map(([proc, list]) => ({ proc, list }));
}

function PerProcessStepwiseGrid({ department, rows, stepMeta, renderStepCell, openUidPopup, openHelpPopup }){
  const groups = groupByProcess_(rows, department);

  return (
    <div className="processGridWrap">
      {groups.map(({ proc, list }, idx) => {
        const meta =
  stepMeta?.[normalizeProc_(proc)] ||
  null;

        let stepKeys = null;
        if (meta?.stepList?.length) {
          stepKeys = meta.stepList;
        } else if (meta?.stepCount) {
          stepKeys = buildKeys_(meta.stepPrefix || "T", meta.stepCount);
        } else {
          // fallback: detect from first row
          stepKeys = getStepKeysForSingleProcessRow_(list[0] || {});
        }

        const wide = stepKeys.length > 12;

        return (
          <div
            key={proc + "|" + idx}
            className={wide ? "processCard fullWidth" : "processCard"}
          >
            <div className="processTitle">
              <div>{proc}</div>
              <div className="processSteps">(Steps: {stepKeys.length})</div>
            </div>

            <div style={{ overflowX: "auto" }}>
              <table className="gridTable">
                <thead>
                  <tr>
                    <th className="dateCol">Date</th>
                    {stepKeys.map((k) => (
                      <th key={k}>{k}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {list.map((r, rIdx) => {
                    const d = fmtDate_(pickDate_(r));
                    return (
                      <tr key={proc + "|" + rIdx}>
                        <td className="dateCol">{d || "—"}</td>
                        {stepKeys.map((k) => {
                          const v = safeStr(r[k] ?? "");
                          const cls = classifyCell_(v);
                          return (
<td key={k} className={cls}>
{v
  ? renderStepCell(
      v,
      openUidPopup,
      openHelpPopup,
      department
    )
  : ""}
</td>          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        );
      })}

<div className="mutedSmall" style={{ marginTop: 6 }}>
  Legend:{" "}
  <span className="cellPlanned" style={{ padding: "2px 8px", borderRadius: 8 }}>
    P = Pending
  </span>{" "}
  <span className="cellDelay" style={{ padding: "2px 8px", borderRadius: 8 }}>
    D = Delay
  </span>
</div>

    </div>
  );
}

function getStepKeysForSingleProcessRow_(r) {
  // Collect Txx / Stepx keys
  const keys = Object.keys(r || {}).filter((k) => /^T\d+$/i.test(k) || /^Step\d+$/i.test(k));

  // Sort numeric
  keys.sort((a, b) => {
    const na = parseInt(a.replace(/\D/g, ""), 10);
    const nb = parseInt(b.replace(/\D/g, ""), 10);
    return na - nb;
  });

  // Find last meaningful step (not empty / not dash)
  let lastIdx = -1;
  for (let i = 0; i < keys.length; i++) {
    const v = safeStr(r[keys[i]]).trim();
    if (v && v !== "—" && v !== "-") lastIdx = i;
  }

  // If everything empty, show first few keys (fallback)
  const upto = lastIdx >= 0 ? lastIdx + 1 : Math.min(keys.length, 5);
  return keys.slice(0, upto);
}

function GenericObjectGrid({
  title,
  rows,
  renderStepCell,
  openUidPopup,
  openHelpPopup,
  type,
  department
}) {
  
  const cols = useMemo(() => {
    const set = new Set();
    rows.forEach((r) => Object.keys(r || {}).forEach((k) => set.add(k)));
    return Array.from(set);
  }, [rows]);

  return (
    <div>
      <div className="mutedSmall" style={{ marginBottom: 8, fontWeight: 800 }}>
        {title}
      </div>

      <div style={{ overflow: "auto" }}>
              {/* ✅ ADD LEGEND HERE */}
      <div className="mutedSmall" style={{ marginTop: 6 }}>
        Legend:{" "}
        <span className="cellPlanned" style={{ padding: "2px 8px", borderRadius: 8 }}>
          P = Pending
        </span>{" "}
        <span className="cellDelay" style={{ padding: "2px 8px", borderRadius: 8 }}>
          D = Delay
        </span>
      </div>

        <table className="gridTable">
          <thead>
            <tr>
              {cols.map((c) => (
                <th key={c} className={c === "Grid_Date" ? "dateColSmall" : ""}>
                  {c}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {rows.map((r, idx) => (
              <tr key={idx}>
{cols.map((c) => {
  const v = safeStr(r?.[c]);

  // ✅ Identify meta columns (NO custom rendering)
// ✅ Identify meta columns (NO custom rendering)
const isMetaColumn =
  c === "Grid_Date" ||
  c === "Indent_Number" ||
  c.includes("Indent");

// ✅ Apply default classification
let cls = isMetaColumn ? "" : classifyCell_(v);

// ✅ Apply color ONLY to actual step columns
if (!isMetaColumn) {

  if (type === "DONE_LATE" && v) {
    cls = "cellDelay";   // 🔴 red
  }

  if (type === "NOT_DONE" && v) {
    cls = "cellPlanned"; // 🟡 yellow
  }

}

  // ✅ Final value to display
  const displayValue = isMetaColumn
    ? (v || "—")   // 🔥 IMPORTANT FIX (date + indent visible)
    : (renderStepCell
        ?  renderStepCell(
    v,
    openUidPopup,
    openHelpPopup,
    department
  )
        : (v || "—"));

  return (
    <td
      key={c}
      className={`${cls} ${c === "Grid_Date" ? "dateColSmall" : ""}`}
    >
      {displayValue}
    </td>
  );
})}
              </tr>
            ))}
          </tbody>
        </table>
      </div>




    </div>
  );
}

function classifyCell_(v) {
  const s = String(v || "").toUpperCase().trim();

  // ✅ extract clean code like 2D, 1P
  const short = s.match(/(\d*D|\d*P)/)?.[0] || "";

  if (/^\d*D$/.test(short)) return "cellDelay";    // 🔴
  if (/^\d*P$/.test(short)) return "cellPlanned";  // 🟡

  if (s.includes("NA")) return "cellNA";
  if (s.includes("DONE")) return "cellDone";
  if (s.includes("ND")) return "cellND";

  return "";
}

function formatPenaltyReason(text) {
  if (!text) return "No reason available";

  const raw = String(text);

  // ✅ If not Accounts/Risk/Dealing format
  // just show original text
  if (!raw.includes("Step:") || !raw.includes("FMS:")) {
    return raw;
  }

  const entries = raw
    .split(",")
    .map(s => s.trim())
    .filter(Boolean);

  const grouped = {};

  entries.forEach(entry => {
    const stepMatch = entry.match(/Step:\s*(T\d+)/i);
    const fmsMatch = entry.match(/FMS:\s*([^,]+)/i);

    if (!stepMatch || !fmsMatch) return;

    const step = stepMatch[1];
    const fms = fmsMatch[1].trim();

    if (!grouped[fms]) grouped[fms] = [];

    grouped[fms].push(step);
  });

  return Object.entries(grouped).map(([fms, steps]) => (
    <div key={fms} style={{ marginBottom: 8 }}>
      <b>FMS:</b> {fms} | <b>Step:</b> {steps.join(", ")}
    </div>
  ));
}
function getSubmissionsFromGroup(list) {
  return (list || []).flatMap((r) => (r?.Latest_Submissions || []));
}

function getSubmissionsFromRow(r) {
  // preferred: array attached per row
  if (Array.isArray(r?.Latest_Submissions) && r.Latest_Submissions.length) {
    return r.Latest_Submissions;
  }
  // fallback: single latest submission
  if (r?.Latest_Submission) return [r.Latest_Submission];
  return [];
}




